<template>
  <div>
    <div ref="card"></div>
    <button @click="purchase">Paga</button>
  </div>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {loadStripe} from '@stripe/stripe-js';
import { EventBus } from '@/event-bus';
export default {
  name: 'Payment',
  components: {

  },
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
    }
  },
  props: {
    click: {
      type: Function,
      default: () => {}
    },
  },  
  watch: {},
  computed: {
    ...mapGetters({
      shop: 'shops/current',
      servicesTotal: 'cart/servicesTotal',
      reservationDate: 'global/reservationDate',
      reservationDateForServer: 'global/reservationDateForServer',
      cart: 'cart/cart',
      stripeClientSecret: 'order/stripeClientSecret',
    }),
    inCart() {
      return this.cart.length > 0
    },
  },
  methods: {
    ...mapActions({     
      getStripeClientSecretId: 'order/getStripeClientSecretId'
    }),
  async purchase() {

    let stripe = this.stripe;
    let client_secter = localStorage.getItem("stripe_client_secret")

    const {token, error} = await stripe.createToken(this.card);

    let confirmCardPayment = await stripe.confirmCardPayment(client_secter, {
        payment_method: {
          card: {
            token: token.id,
          },        
          billing_details: {
            name: 'Fabrizio Corbacio'
          }
        }
      });   

      console.log("step 1")

      return confirmCardPayment
    },    
  },
  async created() {
    EventBus.$on('stripePurchase', async () => {      
      console.log("on stripe-purchase")
      return await this.purchase()
    })
  },
  async mounted() {    
    this.getStripeClientSecretId({ amount: 60, stripe_pub_key: this.shop.stid_merchant })
    if(this.shop.stid_merchant) {
      this.stripe = await loadStripe(this.shop.stid_merchant);
      this.elements = this.stripe.elements();    
      this.card = this.elements.create('card');
      this.card.mount(this.$refs.card);
    }    
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/shop/pages/Stripe.vue